import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Department, TransportationType } from '@signal/asp-data-commons';
import { Observable, of, Subject } from 'rxjs';
import { MasterSlot, ShopMaxPerDay, SlotsPerDay } from '../../shared/models/slot-management.model';
import { SlotState } from '../../store/slot/slot.reducer';
import * as fromActions from '../../store/slot/slot.actions';
import * as fromSelector from '../../store/slot/slot.selectors';
import { TranslateService} from '@ngx-translate/core';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { INavigateAway } from '../../shared/guards/NavigationGuard';
import { exitConfig, unsubscribeSubscriptions } from '../../shared/services/util.service';
import { SubscriptionList } from '../../shared/models/asp.types';

@Component({
  selector: 'app-transport-capacity',
  templateUrl: './transport-capacity.component.html',
  styleUrls: ['./transport-capacity.component.scss']
})
export class TransportCapacityComponent implements OnInit,INavigateAway, OnDestroy {

  viewMode : TransportationType = TransportationType.SHUTTLE;
  maxTotal$: Observable<ShopMaxPerDay[]>;
  slotDetails$: Observable<SlotsPerDay[]>;
  maxAndMasterSlots$: Observable<{ max: any, masterSlot: MasterSlot[] }>;
  loading = false;
  shuttleIndicator$: Observable<any>;
  shuttleActivate: {}
  rentalIndicator$: Observable<any>;
  rentalActivate: {}
  remoteIndicator$: Observable<any>;
  remoteActivate: {}
  loadedView=true;
  masterSlotsLoading$: Observable<boolean>;
  //save clicked 
  isSavedClicked=false;
  isShuttleSlotsPerDaySaveClicked=false
  //cancel clicked
  isCancelClicked=false;
  isMaxSlotsPerTimePeriodCancleClicked=false
 //forms edited
  isMaxSlotsPerDayEdited=false;
  isMaxSlotsPerTimePeriodEdited=false;
  bothFormsEdited=false;
  department = Department.SERVICE;
  private subs: SubscriptionList = {};

  constructor(private readonly slotState: Store<SlotState>,
              private readonly translate: TranslateService,
              private readonly cdr: ChangeDetectorRef,
              private readonly dialog: MatDialog,
              ) {
      this.setUpStore();
   }

  ngOnInit(): void {
  }
  ngAfterContentChecked(): void { 
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

 //checks if navigation is allowed 
 canExit():Observable<boolean> { 
  const result = new Subject<boolean>();
  const dialogRef = this.dialog.open(ConfirmDialogComponent, exitConfig
    );
  this.subs.dialog = dialogRef.afterClosed().subscribe(event => {
  
    if (event.action === 'confirm') {
      this.onSaveClicked();
      result.next(true);
      result.complete();
    }
    else if(event.action === 'close'){
      result.next(true);
      result.complete();
    }
    else{}
  });
  return result.asObservable(); 
};

  //show alert when switching to another tab if unsaved changes
  showAlert(mode)
  {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, exitConfig);
    this.subs.alertDialog = dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') {
        this.onSaveClicked();
        this.loadView(mode);    
      }
      else if(event.action === 'close'){
        this.onCancelClicked();
        this.loadView(mode);    
      }
    });
  }

  // returns if the forms are not edited
  formsEdited()
  {
    return this.isMaxSlotsPerDayEdited || this.isMaxSlotsPerTimePeriodEdited;
  }

  loadView(mode){
    this.loading = true;
    this.viewMode = mode;
    if(this.viewMode==this.transport.SHUTTLE) {
      this.loadedView=this.shuttleActivate as boolean;
    }
    if(this.viewMode==this.transport.RENTAL) {
      this.loadedView=this.rentalActivate as boolean;
    }

    if(this.viewMode==this.transport.REMOTE) {
      this.loadedView=this.remoteActivate as boolean;
    }

    //resetting data of observables
    //this.maxTotal$ = of([]);
    this.slotDetails$ = this.slotState.select(fromSelector.selectEmptySlots);
    //this.maxAndMasterSlots$ = of({ max: [], masterSlot: [] });

    setTimeout( () => {
        //setting data to observables
      this.slotState.dispatch(new fromActions.LoadTransportMaxTotal({transport: this.viewMode}));
      this.slotState.dispatch(new fromActions.LoadTransportMaxSlots({transport: this.viewMode}));
      this.maxTotal$ = this.slotState.select(fromSelector.selectTransportMaxTotal, {view: this.viewMode});
      this.slotDetails$ = this.slotState.select(fromSelector.selectTransportMaxSlots, {view: this.viewMode});
      this.maxAndMasterSlots$ = this.slotState.select(fromSelector.selectTransportMaxAndMasterSlots, {view: this.viewMode});
      this.masterSlotsLoading$ = this.slotState.select(fromSelector.selectMasterSlotsLoading);
      this.loading = false;
      }, 0);


  }

  updateSwitchValues(val: boolean, property: string) {
    switch (property) {
      case 'shuttle':
        this.shuttleActivate = val;
        this.loadedView=val;
        this.slotState.dispatch(new fromActions.UpdateShuttleActivateIndicators({ indicator : val }))
        break;
      case 'rental':
        this.rentalActivate = val;
        this.loadedView=val;
        this.slotState.dispatch(new fromActions.UpdateRentalActivateIndicators({ indicator : val }))
        break;
      case 'remote':
        this.remoteActivate = val;
        this.loadedView=val;
        this.slotState.dispatch(new fromActions.UpdateRemoteActivateIndicators({ indicator : val }))
        break;

        default:
          break;
      }
  }

  get transport(){
    return TransportationType;
  }

  onTotalSaveChanges(slotDetails){
    this.slotState.dispatch(new fromActions.UpdateTransportMaxTotal(
      {
        transport: this.viewMode,
        transportMaxTotal : slotDetails,
      }));
  }
  viewModeText(viewMode){

    if(viewMode.toUpperCase() === 'RENTAL')
      {
        return this.translate.instant('transportCapacity.rentalMaxSlotsPerTimePeriod');
      }
      else if(viewMode.toUpperCase() === 'SHUTTLE')
      {
        return this.translate.instant('transportCapacity.shuttleMaxSlotsPerTimePeriod');
      }
      else if(viewMode.toUpperCase() === 'REMOTE')
      {
        return this.translate.instant('transportCapacity.remoteMaxSlotsPerTimePeriod');
      }
      else{
        return `${viewMode} Max Slots Per TimePeriod`
      }
 }

  onSlotsSaveChanges(slotDetails){
    this.slotState.dispatch(new fromActions.UpdateTransportMaxSlots(
      { transport: this.viewMode, transportMaxSlots: slotDetails,
      bothFormsEdited:this.bothFormsEdited }
    ));
    this.isSavedClicked=false
  }
  setUpStore(){
    this.slotState.dispatch(new fromActions.LoadMasterSlots());
    this.loadView(this.viewMode);
    this.slotState.dispatch(new fromActions.LoadShuttleActivateIndicators());
    this.slotState.dispatch(new fromActions.LoadRentalActivateIndicators());
    this.slotState.dispatch(new fromActions.LoadRemoteActivateIndicators());

    this.shuttleIndicator$ = this.slotState.select(fromSelector.selectShuttleActivateIndicators);
    this.subs.shuttleIndicator = this.shuttleIndicator$.subscribe(ActivateIndicator => {
      this.shuttleActivate = ActivateIndicator['indicator'];
      this.loadedView=this.shuttleActivate as boolean;
    })

    this.rentalIndicator$ = this.slotState.select(fromSelector.selectRentalActivateIndicators);
    this.subs.rentalIndicator = this.rentalIndicator$.subscribe(ActivateIndicator => {
      this.rentalActivate = ActivateIndicator['indicator'];
    })

    this.remoteIndicator$ = this.slotState.select(fromSelector.selectRemoteActivateIndicators);
    this.subs.remoteIndicator = this.remoteIndicator$.subscribe(ActivateIndicator => {
      this.remoteActivate = ActivateIndicator['indicator'];
    })
  }
  // returns if the forms are edited
  formsNotEdited()
  {
    return !this.isMaxSlotsPerDayEdited && !this.isMaxSlotsPerTimePeriodEdited;
  }

  //save button clicked
  onSaveClicked()
  {
    this.isShuttleSlotsPerDaySaveClicked=this.isMaxSlotsPerDayEdited?true:false
    this.isSavedClicked=this.isMaxSlotsPerTimePeriodEdited?true:false
    this.bothFormsEdited=(this.isMaxSlotsPerDayEdited && this.isMaxSlotsPerTimePeriodEdited) && this.isMaxSlotsPerTimePeriodEdited?true:false
    // detect changes after manually calling onSaveClicked()
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  //cancel button clicked 
  onCancelClicked()
  {
    this.isCancelClicked=this.isMaxSlotsPerDayEdited?true:false
    this.isMaxSlotsPerTimePeriodCancleClicked=this.isMaxSlotsPerTimePeriodEdited?true:false
  }

  //reset cancle button clicked value for 1st form
  resetCancleClickValue(event)
  {
    this.isCancelClicked=event
    this.isMaxSlotsPerDayEdited=event
  }

   //reset cancle button clicked value for 2nd form
  resetCancleClickedPerTimePeriod(event)
  {
    this.isMaxSlotsPerTimePeriodCancleClicked=event
    this.isMaxSlotsPerTimePeriodEdited=event
  }

  //reset save button value cliked from 1st from
  resetSaveClickedValue(event)
  {
    this.isShuttleSlotsPerDaySaveClicked=event
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  //Appointment per day form edited 
  maxSlotsPerDayFormEdited(event)
  {
    this.isMaxSlotsPerDayEdited=event
  }

   //Appointment per time period form edited 
   maxSlotsPerTimeTableFormEdited(event)
   {
     this.isMaxSlotsPerTimePeriodEdited=event
   }

   ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
    this.cdr.detach();
  }
}
